import moment from 'moment';

export function formatFullDateTime(datetimeString: string): string {
  const date = new Date(datetimeString);

  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
    timeZoneName: 'short',
  };

  const formattedDate = date.toLocaleString('en-US', options);

  // Remove the time zone name and replace it with "P1"
  const formattedDateWithoutTZ = formattedDate.replace(/ GMT.*/, '').trim();

  return `${formattedDateWithoutTZ} P1`;
}

export function formatDate(datetimeString: string): string {
  const date = new Date(datetimeString);

  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  };

  const formattedDate = date.toLocaleString('en-US', options);

  // Remove the time zone name and replace it with "P1"
  const formattedDateWithoutTZ = formattedDate.replace(/ GMT.*/, '').trim();

  return formattedDateWithoutTZ;
}

export const calculateDaysDifference = (endDate: Date) => {
  if (endDate) {
    const endMoment = moment(endDate);
    const today = moment();
    const daysLeft = endMoment.diff(today, 'days'); // Calculate the difference in days
    return daysLeft;
  }
  return 10; // Default to 10 days if no endDate is provided
};

export function getRelativeTime(dateString: string): string {
  return moment(dateString).fromNow(); // e.g., "2 days ago"
}

export function getDateRangeInDays(startDate: string, endDate: string): string {
  const start = moment(startDate);
  const end = moment(endDate);

  // Inclusive difference: add 1 day to the result
  const days = end.diff(start, 'days') + 1;

  return `${days} day${days === 1 ? '' : 's'}`;
}

export const formatDateToMMMDYYYY = (
  dateString: string | null | undefined
): string => {
  if (!dateString) return '';
  return moment(dateString).format('MMM D, YYYY');
};

export function formatDateFromDate(date: Date | null | undefined): string {
  if (!date || isNaN(date.getTime())) {
    return '';
  }

  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  };

  const formattedDate = date.toLocaleString('en-US', options);

  // Remove the time zone name and replace it with "P1"
  const formattedDateWithoutTZ = formattedDate.replace(/ GMT.*/, '').trim();

  return formattedDateWithoutTZ;
}
